import { createContext } from 'react';

import { ApiDataType, IUserDetailBase, userType } from '@/types';

interface UserInfoContextType {
	userInfoContext: ApiDataType<userType, string[]> | null;
	setUserInfoContext?: React.Dispatch<
		React.SetStateAction<UserInfoContextType['userInfoContext']>
	>;
	userDetailInfoContext: ApiDataType<IUserDetailBase, string[]> | null;
	setUserDetailInfoContext?: React.Dispatch<
		React.SetStateAction<UserInfoContextType['userDetailInfoContext']>
	>;
}

const defaultValue = {
	userInfoContext: null,
	userDetailInfoContext: null,
};

export const UserInfoContext = createContext<UserInfoContextType>(defaultValue);
